import { createContext } from 'react';

export const PageLoadingContext = createContext(undefined);
export const PageLoadingProvider = PageLoadingContext.Provider;
